(function () {
    document.addEventListener('DOMContentLoaded', function () {
        const cookieSettingsButton = document.querySelector('[href="#cookie-settings"]');
        if (cookieSettingsButton) {
            cookieSettingsButton.addEventListener('click', (e) => {
                e.preventDefault();
                privacyBanner.showPreferences();
            });
        }
    });
})();